import UploadAudioAction from './UploadAudioAction';

export default UploadAudioAction;
